import React, { useState } from 'react';
import { LayoutGridIcon, PlusIcon, BarChartIcon, SearchIcon, FilterIcon, MoreHorizontalIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon, CalendarIcon, XIcon } from 'lucide-react';
import { SuccessNotification } from '../shared/SuccessNotification';
interface TicketFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
}
const TicketFormModal: React.FC<TicketFormModalProps> = ({
  isOpen,
  onClose,
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    title: '',
    category: 'Perbaikan',
    priority: 'Sedang',
    unit: '',
    assignee: '',
    dueDate: '',
    description: ''
  });
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({
      title: '',
      category: 'Perbaikan',
      priority: 'Sedang',
      unit: '',
      assignee: '',
      dueDate: '',
      description: ''
    });
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-3155">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col" data-id="element-3156">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-neutral-light" data-id="element-3157">
          <h2 className="text-xl font-bold text-secondary flex items-center" data-id="element-3158">
            <LayoutGridIcon size={20} className="mr-2 text-primary" data-id="element-3159" />
            Buat Ticket Baru
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200 transition-colors" data-id="element-3160">
            <XIcon size={20} className="text-gray-500" data-id="element-3161" />
          </button>
        </div>
        <div className="overflow-y-auto p-6 flex-grow" data-id="element-3162">
          <form id="ticket-form" onSubmit={handleSubmit} className="space-y-4" data-id="element-3163">
            <div className="space-y-1" data-id="element-3164">
              <label className="text-sm font-medium text-gray-700" data-id="element-3165">
                Judul Ticket <span className="text-red-500" data-id="element-3166">*</span>
              </label>
              <input type="text" required value={formData.title} onChange={e => setFormData({
              ...formData,
              title: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Ringkasan masalah atau permintaan" data-id="element-3167" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-3168">
              <div className="space-y-1" data-id="element-3169">
                <label className="text-sm font-medium text-gray-700" data-id="element-3170">
                  Kategori <span className="text-red-500" data-id="element-3171">*</span>
                </label>
                <select value={formData.category} onChange={e => setFormData({
                ...formData,
                category: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3172">
                  <option value="Perbaikan" data-id="element-3173">Perbaikan</option>
                  <option value="Inspeksi" data-id="element-3174">Inspeksi</option>
                  <option value="Pengadaan" data-id="element-3175">Pengadaan</option>
                  <option value="Strategis" data-id="element-3176">Strategis</option>
                  <option value="Darurat" data-id="element-3177">Darurat</option>
                </select>
              </div>
              <div className="space-y-1" data-id="element-3178">
                <label className="text-sm font-medium text-gray-700" data-id="element-3179">
                  Prioritas <span className="text-red-500" data-id="element-3180">*</span>
                </label>
                <select value={formData.priority} onChange={e => setFormData({
                ...formData,
                priority: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3181">
                  <option value="Tinggi" data-id="element-3182">Tinggi</option>
                  <option value="Sedang" data-id="element-3183">Sedang</option>
                  <option value="Rendah" data-id="element-3184">Rendah</option>
                </select>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-3185">
              <div className="space-y-1" data-id="element-3186">
                <label className="text-sm font-medium text-gray-700" data-id="element-3187">
                  Unit Penanggung Jawab
                </label>
                <input type="text" value={formData.unit} onChange={e => setFormData({
                ...formData,
                unit: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Contoh: Fasilitas" data-id="element-3188" />
              </div>
              <div className="space-y-1" data-id="element-3189">
                <label className="text-sm font-medium text-gray-700" data-id="element-3190">
                  Assignee (Inisial)
                </label>
                <input type="text" value={formData.assignee} onChange={e => setFormData({
                ...formData,
                assignee: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Contoh: ENG" maxLength={3} data-id="element-3191" />
              </div>
            </div>
            <div className="space-y-1" data-id="element-3192">
              <label className="text-sm font-medium text-gray-700" data-id="element-3193">
                Tenggat Waktu <span className="text-red-500" data-id="element-3194">*</span>
              </label>
              <input type="date" required value={formData.dueDate} onChange={e => setFormData({
              ...formData,
              dueDate: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3195" />
            </div>
            <div className="space-y-1" data-id="element-3196">
              <label className="text-sm font-medium text-gray-700" data-id="element-3197">
                Deskripsi Detail
              </label>
              <textarea rows={3} value={formData.description} onChange={e => setFormData({
              ...formData,
              description: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Jelaskan detail permintaan atau masalah..." data-id="element-3198" />
            </div>
          </form>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-end space-x-2 bg-gray-50" data-id="element-3199">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-100" data-id="element-3200">
            Batal
          </button>
          <button type="submit" form="ticket-form" className="px-4 py-2 bg-primary text-secondary rounded-md text-sm font-medium hover:bg-opacity-90" data-id="element-3201">
            Buat Ticket
          </button>
        </div>
      </div>
    </div>;
};
export const TaskBoard: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    message: ''
  });
  // Kanban Columns based on KAK
  const columns = [{
    id: 'pr',
    title: 'PR / Pending Request',
    headerBg: 'bg-gray-100',
    headerText: 'text-gray-700',
    dotColor: 'bg-gray-400'
  }, {
    id: 'progress',
    title: 'On Progress',
    headerBg: 'bg-blue-50',
    headerText: 'text-blue-700',
    dotColor: 'bg-blue-500'
  }, {
    id: 'followup',
    title: 'Follow-Up',
    headerBg: 'bg-yellow-50',
    headerText: 'text-yellow-700',
    dotColor: 'bg-yellow-500'
  }, {
    id: 'done',
    title: 'Done / Selesai',
    headerBg: 'bg-green-50',
    headerText: 'text-green-700',
    dotColor: 'bg-green-500'
  }, {
    id: 'archive',
    title: 'Archive / Closed',
    headerBg: 'bg-gray-200',
    headerText: 'text-gray-600',
    dotColor: 'bg-gray-500'
  }];
  const [tickets, setTickets] = useState([{
    id: 'TKT-2026-001',
    title: 'Perbaikan Atap Gedung Deputi V',
    category: 'Perbaikan',
    priority: 'Tinggi',
    status: 'pr',
    unit: 'Deputi V',
    dueDate: '15 Jan 2026',
    assignee: 'BS'
  }, {
    id: 'TKT-2026-002',
    title: 'Pengadaan Laptop Operasional',
    category: 'Pengadaan',
    priority: 'Sedang',
    status: 'pr',
    unit: 'Setuma',
    dueDate: '20 Jan 2026',
    assignee: 'AD'
  }, {
    id: 'TKT-2026-003',
    title: 'Inspeksi Rutin Server Farm',
    category: 'Inspeksi',
    priority: 'Rendah',
    status: 'pr',
    unit: 'Pusat Data',
    dueDate: '25 Jan 2026',
    assignee: 'IT'
  }, {
    id: 'TKT-2026-004',
    title: 'Instalasi CCTV Gedung Utama',
    category: 'Strategis',
    priority: 'Tinggi',
    status: 'progress',
    unit: 'Keamanan',
    dueDate: '10 Jan 2026',
    assignee: 'SEC'
  }, {
    id: 'TKT-2026-005',
    title: 'Maintenance Genset Backup',
    category: 'Perbaikan',
    priority: 'Tinggi',
    status: 'progress',
    unit: 'Fasilitas',
    dueDate: '12 Jan 2026',
    assignee: 'ENG'
  }, {
    id: 'TKT-2026-006',
    title: 'Update Lisensi Firewall',
    category: 'Darurat',
    priority: 'Tinggi',
    status: 'followup',
    unit: 'IT Sec',
    dueDate: '08 Jan 2026',
    assignee: 'NET'
  }, {
    id: 'TKT-2026-007',
    title: 'Audit Aset Semester 2',
    category: 'Inspeksi',
    priority: 'Sedang',
    status: 'done',
    unit: 'Internal Audit',
    dueDate: '31 Des 2025',
    assignee: 'AUD'
  }, {
    id: 'TKT-2026-008',
    title: 'Servis AC Lantai 3',
    category: 'Perbaikan',
    priority: 'Rendah',
    status: 'done',
    unit: 'Fasilitas',
    dueDate: '28 Des 2025',
    assignee: 'ENG'
  }, {
    id: 'TKT-2025-158',
    title: 'Perbaikan AC Ruang Server',
    category: 'Perbaikan',
    priority: 'Tinggi',
    status: 'archive',
    unit: 'Fasilitas',
    dueDate: '15 Des 2025',
    assignee: 'ENG'
  }]);
  const handleAddTicket = () => {
    setIsModalOpen(true);
  };
  const handleSubmit = (data: any) => {
    const newTicket = {
      ...data,
      id: `TKT-${new Date().getFullYear()}-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
      status: 'pr',
      // Format date nicely if needed, or keep as YYYY-MM-DD
      dueDate: new Date(data.dueDate).toLocaleDateString('id-ID', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      })
    };
    setTickets([newTicket, ...tickets]);
    setIsModalOpen(false);
    setNotification({
      show: true,
      message: `Ticket ${newTicket.id} berhasil dibuat`
    });
  };
  const handleStats = () => {
    setNotification({
      show: true,
      message: 'Statistik ticket diperbarui'
    });
  };
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'Perbaikan':
        return 'bg-orange-100 text-orange-800';
      case 'Inspeksi':
        return 'bg-blue-100 text-blue-800';
      case 'Pengadaan':
        return 'bg-purple-100 text-purple-800';
      case 'Strategis':
        return 'bg-indigo-100 text-indigo-800';
      case 'Darurat':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'Tinggi':
        return 'text-red-600 bg-red-50 border-red-200';
      case 'Sedang':
        return 'text-yellow-600 bg-yellow-50 border-yellow-200';
      case 'Rendah':
        return 'text-green-600 bg-green-50 border-green-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };
  const filteredTickets = tickets.filter(t => !searchQuery || t.title.toLowerCase().includes(searchQuery.toLowerCase()) || t.id.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-4" data-id="element-3202">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4" data-id="element-3203">
        <div data-id="element-3204">
          <h1 className="text-xl sm:text-2xl font-bold text-secondary flex items-center" data-id="element-3205">
            <LayoutGridIcon size={24} className="mr-2 text-primary" data-id="element-3206" />
            Task & Ticketing Operasional
          </h1>
          <p className="text-gray-500 text-sm mt-1" data-id="element-3207">
            Manajemen tugas, tiket perbaikan, dan workflow operasional.
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-3208">
          <button onClick={handleStats} className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90 flex items-center text-sm" data-id="element-3209">
            <BarChartIcon size={16} className="mr-2" data-id="element-3210" />
            Statistik
          </button>
          <button onClick={handleAddTicket} className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium flex items-center text-sm" data-id="element-3211">
            <PlusIcon size={16} className="mr-2" data-id="element-3212" />
            Buat Ticket
          </button>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-3213">
        {[{
        label: 'Total Ticket',
        value: tickets.length.toString(),
        color: 'text-secondary',
        icon: <LayoutGridIcon size={18} data-id="element-3214" />,
        bg: 'bg-gray-100'
      }, {
        label: 'Dalam Proses',
        value: tickets.filter(t => t.status === 'progress').length.toString(),
        color: 'text-blue-600',
        icon: <ClockIcon size={18} data-id="element-3215" />,
        bg: 'bg-blue-50'
      }, {
        label: 'Menunggu Tindakan',
        value: tickets.filter(t => t.status === 'pr').length.toString(),
        color: 'text-yellow-600',
        icon: <AlertCircleIcon size={18} data-id="element-3216" />,
        bg: 'bg-yellow-50'
      }, {
        label: 'Selesai Bulan Ini',
        value: tickets.filter(t => t.status === 'done').length.toString(),
        color: 'text-green-600',
        icon: <CheckCircleIcon size={18} data-id="element-3217" />,
        bg: 'bg-green-50'
      }].map(stat => <div key={stat.label} className="bg-white p-3 sm:p-4 rounded-lg border border-gray-200 shadow-sm flex items-center justify-between" data-id="element-3218">
            <div data-id="element-3219">
              <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-3220">
                {stat.label}
              </p>
              <p className={`text-xl sm:text-2xl font-bold ${stat.color}`} data-id="element-3221">
                {stat.value}
              </p>
            </div>
            <div className={`p-2.5 ${stat.bg} rounded-full ${stat.color}`} data-id="element-3222">
              {stat.icon}
            </div>
          </div>)}
      </div>

      {/* Filter Bar */}
      <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm flex flex-wrap gap-3 items-center justify-between" data-id="element-3223">
        <div className="relative flex-grow max-w-md" data-id="element-3224">
          <input type="text" placeholder="Cari ticket ID, judul, atau assignee..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-3225" />
          <SearchIcon size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-3226" />
        </div>
        <div className="flex items-center gap-2" data-id="element-3227">
          <button className="flex items-center px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-200 text-sm" data-id="element-3228">
            <FilterIcon size={14} className="mr-1" data-id="element-3229" />
            Filter
          </button>
          <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3230">
            <option value="" data-id="element-3231">Semua Kategori</option>
            <option value="Perbaikan" data-id="element-3232">Perbaikan</option>
            <option value="Inspeksi" data-id="element-3233">Inspeksi</option>
            <option value="Pengadaan" data-id="element-3234">Pengadaan</option>
            <option value="Strategis" data-id="element-3235">Strategis</option>
            <option value="Darurat" data-id="element-3236">Darurat</option>
          </select>
          <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3237">
            <option value="" data-id="element-3238">Semua Prioritas</option>
            <option value="Tinggi" data-id="element-3239">Tinggi</option>
            <option value="Sedang" data-id="element-3240">Sedang</option>
            <option value="Rendah" data-id="element-3241">Rendah</option>
          </select>
        </div>
      </div>

      {/* Kanban Board */}
      <div className="overflow-x-auto pb-4 -mx-3 sm:-mx-4 px-3 sm:px-4" data-id="element-3242">
        <div className="flex gap-3 min-w-[1100px]" data-id="element-3243">
          {columns.map(column => {
          const columnTickets = filteredTickets.filter(t => t.status === column.id);
          return <div key={column.id} className="flex-1 min-w-[220px] flex flex-col bg-gray-50 rounded-lg border border-gray-200" data-id="element-3244">
                {/* Column Header */}
                <div className={`p-3 rounded-t-lg border-b border-gray-200 flex justify-between items-center ${column.headerBg}`} data-id="element-3245">
                  <div className="flex items-center" data-id="element-3246">
                    <span className={`w-2.5 h-2.5 rounded-full mr-2 ${column.dotColor}`} data-id="element-3247"></span>
                    <h3 className={`font-bold text-sm ${column.headerText}`} data-id="element-3248">
                      {column.title}
                    </h3>
                  </div>
                  <span className="bg-white text-gray-600 text-xs font-medium px-2 py-0.5 rounded-full border border-gray-200" data-id="element-3249">
                    {columnTickets.length}
                  </span>
                </div>

                {/* Column Content */}
                <div className="p-2 space-y-2 max-h-[500px] overflow-y-auto" data-id="element-3250">
                  {columnTickets.map(ticket => <div key={ticket.id} className={`bg-white p-3 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer group border-l-4 ${ticket.priority === 'Tinggi' ? 'border-l-red-400' : ticket.priority === 'Sedang' ? 'border-l-yellow-400' : 'border-l-green-400'}`} data-id="element-3251">
                      <div className="flex justify-between items-start mb-2" data-id="element-3252">
                        <span className="text-[10px] font-mono text-gray-400 bg-gray-50 px-1.5 py-0.5 rounded" data-id="element-3253">
                          {ticket.id}
                        </span>
                        <button className="text-gray-400 hover:text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-3254">
                          <MoreHorizontalIcon size={14} data-id="element-3255" />
                        </button>
                      </div>

                      <h4 className="font-medium text-secondary text-sm mb-2 leading-snug" data-id="element-3256">
                        {ticket.title}
                      </h4>

                      <div className="flex flex-wrap gap-1.5 mb-2" data-id="element-3257">
                        <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${getCategoryColor(ticket.category)}`} data-id="element-3258">
                          {ticket.category}
                        </span>
                        <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium border ${getPriorityColor(ticket.priority)}`} data-id="element-3259">
                          {ticket.priority}
                        </span>
                      </div>

                      <div className="flex items-center justify-between pt-2 border-t border-gray-100" data-id="element-3260">
                        <div className="flex items-center text-[10px] text-gray-500" data-id="element-3261">
                          <CalendarIcon size={10} className="mr-1" data-id="element-3262" />
                          {ticket.dueDate}
                        </div>
                        {ticket.status === 'done' || ticket.status === 'archive' ? <span className="text-[10px] text-green-600 flex items-center font-medium" data-id="element-3263">
                            <CheckCircleIcon size={10} className="mr-0.5" data-id="element-3264" />
                            Selesai
                          </span> : <div className="w-6 h-6 rounded-full bg-secondary text-white flex items-center justify-center text-[10px] font-medium" title={ticket.assignee} data-id="element-3265">
                            {ticket.assignee}
                          </div>}
                      </div>
                    </div>)}

                  {column.id === 'pr' && <button onClick={handleAddTicket} className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-gray-400 text-xs font-medium hover:border-primary hover:text-primary transition-colors flex items-center justify-center" data-id="element-3266">
                      <PlusIcon size={14} className="mr-1" data-id="element-3267" />
                      Tambah Ticket
                    </button>}
                </div>
              </div>;
        })}
        </div>
      </div>

      <TicketFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSubmit={handleSubmit} data-id="element-3268" />

      <SuccessNotification message={notification.message} isVisible={notification.show} onClose={() => setNotification({
      ...notification,
      show: false
    })} data-id="element-3269" />
    </div>;
};